import React, { useState } from 'react'
import { Dimmer, Loader, Header, Icon } from 'semantic-ui-react'

import { attemptDocumentExport } from 'EditorApp/actions/doc'
import useTimeout from '../hooks/useTimeout'

const ExportPage = () => {
  const [isExporting, setIsExporting] = useState(true)
  const [exportError, setExportError] = useState(null)

  const onExportComplete = (errorMessage) => {
    setIsExporting(false)
    setExportError(errorMessage || null)
  }

  useTimeout(() => {
    if (isExporting) {
      attemptDocumentExport(window.location.href, onExportComplete)
    }
  }, 2000)

  return (
    <Dimmer active={true} page>
      {isExporting ? (
        <Loader indeterminate>Preparing File</Loader>
      ) : (
        <Header as="h2" icon inverted>
          <Icon name={exportError ? 'warning sign' : 'cloud download'} />
          {exportError || 'Export complete'}
        </Header>
      )}
    </Dimmer>
  )
}

export default ExportPage
